"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserialize = void 0;
const errors_1 = require("../../errors");
function deserialize(data) {
    try {
        return JSON.parse(decodeURI(data));
    }
    catch (error) {
        throw new errors_1.SerializationError(`Could not deserialize value: ${data}`);
    }
}
exports.deserialize = deserialize;
//# sourceMappingURL=deserialize.js.map